module.exports = __webpack_public_path__ + "static/media/finestar.29c01810.svg";